<template>
  <div class="page-myaccount">
    <h1 class="title">Mon compte</h1>

    <!-- Notifications -->
    <div
      v-if="notification.message"
      class="notification"
      :class="notification.type"
    >
      {{ notification.message }}
      <button class="delete" @click="notification.message = ''"></button>
    </div>

    <div class="columns">
      <!-- === User info === -->
      <div class="column is-half">
        <div class="box">
          <h2 class="subtitle">Informations utilisateur</h2>

          <div class="field">
            <label class="label">Nom d'utilisateur</label>
            <input v-model="form.username" class="input" type="text" disabled />
          </div>

          <div class="field">
            <label class="label">Nom</label>
            <input v-model="form.last_name" class="input" type="text" />
          </div>

          <div class="field">
            <label class="label">Prénom</label>
            <input v-model="form.first_name" class="input" type="text" />
          </div>

          <div class="field">
            <label class="label">Email</label>
            <input v-model="form.email" class="input" type="email" disabled />
          </div>

          <div class="field mt-4">
            <button
              class="button is-primary"
              @click="updateProfile"
              :disabled="loading"
            >
              <span v-if="loading" class="loader"></span>
              <span v-else>Mettre à jour</span>
            </button>
          </div>
        </div>
      </div>

      <!-- === Organization info === -->
      <div class="column is-half">
        <div class="box">
          <h2 class="subtitle">Organisation(s)</h2>

          <div
            v-for="m in form.memberships"
            :key="m.id"
            class="membership-card mb-3"
          >
            <p><strong>Nom :</strong> {{ m.organization.name }}</p>
            <p><strong>Numéro :</strong> {{ m.organization.org_number }}</p>
            <p><strong>Rôle :</strong> {{ m.role }}</p>
          </div>

          <div class="field mt-4">
            <button class="button is-link is-light" @click="switchOrganization">
              Changer d’organisation
            </button>
          </div>
          <router-link class="button is-light mt-3" to="/organization/peppol">
            Gérer l'enregistrement Peppol
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/axios';

export default {
  name: 'MyAccount',
  data() {
    return {
      form: {
        username: '',
        first_name: '',
        last_name: '',
        email: '',
        memberships: [],
      },
      notification: {
        message: '',
        type: '', // ex: 'notification is-success'
      },
      loading: false,
    };
  },
  methods: {
    async fetchData() {
      try {
        const res = await api.get('auth/users/me/');
        this.form = res.data;
      } catch (err) {
        console.error('Erreur chargement profil:', err);
        this.notify('Erreur lors du chargement du profil', 'is-danger');
      }
    },
    async updateProfile() {
      // Comments in English
      this.loading = true;
      try {
        // Build a partial payload for PATCH (only fields you actually edit in UI)
        const payload = {
          first_name: this.form.first_name,
          last_name: this.form.last_name,
          // add other editable fields here if needed
        };

        // Try PATCH first (partial update)
        await api.patch('auth/users/me/', payload);
        this.notify('Profil mis à jour avec succès', 'is-success');
      } catch (err) {
        // If PATCH not allowed or backend requires full object, fallback to PUT
        const status = err?.response?.status;
        const notAllowed =
          status === 405 || /patch/i.test(err?.response?.data || '');
        if (notAllowed) {
          try {
            // PUT requires required fields (username/email) + your changes
            await api.put('auth/users/me/', {
              username: this.form.username,
              email: this.form.email,
              first_name: this.form.first_name,
              last_name: this.form.last_name,
            });
            this.notify('Profil mis à jour avec succès', 'is-success');
          } catch (e2) {
            // Show server validation messages if present
            const msg =
              (e2.response && JSON.stringify(e2.response.data)) ||
              'Erreur lors de la mise à jour';
            this.notify(msg, 'is-danger');
          }
        } else {
          const msg =
            (err.response && JSON.stringify(err.response.data)) ||
            'Erreur lors de la mise à jour';
          this.notify(msg, 'is-danger');
        }
      } finally {
        this.loading = false;
      }
    },
    switchOrganization() {
      // ton code de switch org
    },
    notify(message, type) {
      this.notification.message = message;
      this.notification.type = `notification ${type}`;
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
.page-myaccount {
  padding: 2rem;
}

.membership-card {
  border: 1px solid #444;
  border-radius: 8px;
  padding: 0.75rem;
}

.loader {
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  animation: spin 1s linear infinite;
  display: inline-block;
  vertical-align: middle;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
